import { render } from "./pqr.vue?vue&type=template&id=47a4c628&scoped=true"
import script from "./pqr.vue?vue&type=script&lang=js"
export * from "./pqr.vue?vue&type=script&lang=js"

import "./pqr.vue?vue&type=style&index=0&id=47a4c628&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a4c628"]])

export default __exports__